export const RTL_LANGUAGES: string[] = ['ar', 'fa', 'fa_PRS', 'he', 'ur'];
